import React from "react";
import { useT } from "@/i18n/useT";

export default function PrivacyPage() {
  const t = useT();
  const p = t.privacy;
  return (
    <div data-testid="privacy-page" className="br-container py-20 md:py-28 max-w-3xl space-y-14">
      <header className="br-fade-in">
        <div className="br-eyebrow mb-4">{p.eyebrow}</div>
        <h1 className="font-serif text-4xl md:text-6xl text-espresso leading-tight">{p.title}</h1>
        <p className="mt-6 text-sm text-walnut">{p.updated}</p>
      </header>
      {p.sections.map((sec, i) => (
        <section key={i} className="space-y-3">
          <h2 className="font-serif text-2xl md:text-3xl text-espresso">{sec.title}</h2>
          <p className="text-base font-light text-dark-walnut leading-relaxed">{sec.body}</p>
        </section>
      ))}
    </div>
  );
}